import {STORAGE_API} from "../constants/localSrotage";

const API_PORT = location.port;
const API_IN_STORAGE = localStorage.getItem(STORAGE_API);
export const HOSTNAME = location.host;

export const LOCALHOST = /localhost/.test(HOSTNAME);
export const DEV = /dev/.test(HOSTNAME);
export const RC = /rc/.test(HOSTNAME);
export const TESTING = /testing/.test(HOSTNAME);
export const SANDBOX = /sandbox/.test(HOSTNAME);

export const API_URL_HOST = API_IN_STORAGE
  ? API_IN_STORAGE
  : location.hostname + (API_PORT ? ':' + API_PORT : '');

export const API_URL_WS_ADMIN = 'wss://' + API_URL_HOST + '/v1/ws/dashboard/admin-console';
export const API_URL_WS = 'wss://' + API_URL_HOST + '/v1/ws/dashboard/console';
export const API_URL_HTTP = 'https://' + API_URL_HOST;
